import React, { Fragment, useEffect } from "react";
import Store from "Store";
import { localeInitActions } from "Actions/localeActions";
import preloadActions from "Actions/preloadActions";
import appActions from "Actions/appActions";

const PreLoad = props => {

    useEffect(() => {
        let language;
        const { country, locale, slToken } = props.match.params;
        const hasLocale = !!(locale || country);
        const dispatch = Store.dispatch;
        const setLocale = (country, locale) => {
            country = country && country.toUpperCase();
            if (locale) {
                let seperateString = function (value, seperator) {
                    return value.split(seperator);
                };
                let seperatedValues = seperateString(locale, "_");
                language = seperatedValues[0];
            }
            language = language ? language.toLowerCase() : "en";
            let localeObj = { language, country };
            let wait = false;
            dispatch(appActions.startOver());
            dispatch(preloadActions.preloadLocale(localeObj));
            dispatch(preloadActions.preloadMarkets(wait));
            props.history.push("/start");
        };

        if (hasLocale && !slToken) {
            setLocale(country, locale);
        } else if (hasLocale && slToken) {
            // pass
        } else if (!hasLocale) {
            dispatch(appActions.startOver());
            dispatch(localeInitActions.initGeoData());
            props.history.push("/start");
        }

    }, []);

    return <Fragment />;

};
export default PreLoad;



// WEBPACK FOOTER //
// ./src/components/PreLoad/PreLoad.js